import { IState } from '../../store';

export function getTotalLiftCounts(state: IState) {
  const {
    offerData: { bti },
  } = state;

  return bti && bti.houseData && bti.houseData.lifts;
}
